import React, { useState, useEffect } from 'react'
import LeftSideMenu from './LeftSideMenu'
import validator from 'validator'
import { useAuth } from "./api/authStore"
import useMobile from './hooks/useMobile'
import MobileMenu from './components/MobileMenu'
import AnimatedBurgerIcon from './components/AnimatedBurgerIcon'

const ChangePassword = (props) => {

    const { getAccessTokenSilently } = useAuth()
    const { isMobile } = useMobile()

    const userData = props.user
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false)

    const [showPassword, setShowPassword] = useState(false)
    const [showRePassword, setShowRePassword] = useState(false)

    const [isError, showError] = useState(false)
    const [errorText, setErrorText] = useState("")

    const [passwordHelperText, setPasswordHelperText] = useState("")
    const [rePasswordHelperText, setRePasswordHelperText] = useState("")
    const [openRePassError, setRePassError] = useState(false)
    const [buttonDisable, setButtonStatus] = useState(true)

    const [open, setOpen] = useState(false)
   
    const [passwd, setPassword] =  useState("")
    const [repasswd, setRePassword] =  useState("")


    const [errorChangePassword, setErrorChangePassword] = useState(false)
    const [successChangePassword, setSuccessChangePassword] = useState(false)

    // Автоматическое скрытие уведомлений через 3 секунды
    useEffect(() => {
        if (successChangePassword) {
            const timer = setTimeout(() => setSuccessChangePassword(false), 4000)
            return () => clearTimeout(timer)
        }
    }, [successChangePassword])

    useEffect(() => {
        if (errorChangePassword) {
            const timer = setTimeout(() => setErrorChangePassword(false), 4000)
            return () => clearTimeout(timer)
        }
    }, [errorChangePassword])

    const handleSetErrorPasswordClose = () => {
        setErrorChangePassword(false)
    }

    const handleSetSuccessPasswordClose = () => {
        setSuccessChangePassword(false)
    }


    const handleClickShowPassword = () => setShowPassword((show) => !show)
    const handleClickShowRePassword = () => setShowRePassword((show) => !show)

    const handleMouseDownPassword = (event) => {
        event.preventDefault()
    }

    const handleChangePasswd = (e) => {
        setPassword(e.target.value)
    }

    const passwordValidate = (value) => {
  
        if (!validator.isStrongPassword(value, {
            minLength: 8, minLowercase: 1,
            minUppercase: 1, minNumbers: 1, minSymbols: 1
        })) {
            setPasswordHelperText("password should be at least 8 chars, 1 lower case, 1 upper case, 1 special chars, 1 number")
            return false
        } else {
            setPasswordHelperText("")
            return true
        }
    }

    const handleValidatePassword = (value) => {
        if (!passwordValidate(value) ){
            setOpen(true)
            setButtonStatus(true)
            setPassword(value)
        } else if(!validateRePassword(repasswd)){
            setRePassError(true)
            setButtonStatus(true)
        } else {
            setButtonStatus(false)
            setOpen(false)
            setRePassError(false)
            setPassword(value)
        }
    }

    const handleChangeRePasswd = (e) => {
        setRePassword(e.target.value)
    }

    const validateRePassword = (repassword) => {
        setRePassword(repassword)

        if(passwd !== repassword) {
            setRePasswordHelperText("Password and Re-password are not equal")
            setRePassError(true)
            setButtonStatus(true)
            
            return false
        } else {
            setRePassError(false)
            setRePasswordHelperText("")
            setButtonStatus(false)
            
            return true
        }
        
        
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        if (buttonDisable) return

        if (!passwordValidate(passwd) || !validateRePassword(repasswd)) {
            return
        }

        try {
            await props.apiClient.setToken(getAccessTokenSilently()).changeUserPassword(userData.userid, passwd)
            setSuccessChangePassword(true)
            // Не очищаем поля сразу — даём браузеру предложить обновить сохранённый пароль
            setTimeout(() => {
                setPassword('')
                setRePassword('')
            }, 3000)
        } catch (e) {
            showError(true)
            setErrorText("Erorr occurs, try again please.")
            setErrorChangePassword(true)
        }
    }

    return (
        <div style={{ display: 'flex', height: '100vh' }}>
            {/* Десктопное меню */}
            {!isMobile && (
                <LeftSideMenu active={props.active} user={props.user} apiClient={props.apiClient}/>
            )}
            
            {/* Основной контент */}
            <div className="shop-page" style={{
                width: isMobile ? '100%' : 'calc(100% - 280px)',
                marginLeft: isMobile ? '0' : '280px',
                padding: isMobile ? '0' : '8px',
                minHeight: '100vh',
                display: 'flex',
                flexDirection: 'column',
                overflow: isMobile ? 'hidden' : 'auto'
            }}>
                {isMobile && (
                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        padding: 'var(--spacing-md)',
                        background: 'var(--dark-gray)',
                        borderBottom: '1px solid var(--light-gray)',
                        position: 'sticky',
                        top: 0,
                        zIndex: 100
                    }}>
                        <AnimatedBurgerIcon
                            isOpen={mobileMenuOpen}
                            onClick={() => setMobileMenuOpen(true)}
                        />
                        <h1 className="shop-page-title" style={{
                            margin: 0,
                            fontSize: 'var(--text-lg)',
                        }}>
                            Account
                        </h1>
                        <div style={{ width: '32px' }} />
                    </div>
                )}

                {isMobile && (
                    <MobileMenu 
                        user={props.user} 
                        active={props.active} 
                        apiClient={props.apiClient}
                        isOpen={mobileMenuOpen}
                        onClose={() => setMobileMenuOpen(false)}
                    />
                )}

                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: isMobile ? 'center' : undefined,
                    flex: 1,
                    padding: isMobile ? 'var(--spacing-md)' : '0',
                    overflow: isMobile ? 'auto' : 'visible'
                }}>
                    {/* Заголовок */}
                    <div style={{
                        marginBottom: isMobile ? 'var(--spacing-lg)' : 'var(--spacing-xl)',
                        width: isMobile ? '100%' : undefined,
                        textAlign: isMobile ? 'center' : undefined
                    }}>
                        {!isMobile && (
                            <h1 className="shop-page-title" style={{
                                marginTop: '8px',
                                marginBottom: '8px',
                                marginLeft: '0px',
                                fontSize: 'var(--text-2xl)',
                            }}>
                                Change Password
                            </h1>
                        )}
                        {isMobile && (
                            <h2 className="shop-page-title" style={{
                                fontSize: 'var(--text-xl)',
                                margin: '0 0 var(--spacing-sm) 0',
                            }}>
                                Change Password
                            </h2>
                        )}
                        <p style={{
                            color: 'var(--text-muted)',
                            fontSize: isMobile ? 'var(--text-sm)' : 'var(--text-base)',
                            margin: '0'
                        }}>
                            {props.text}
                        </p>
                    </div>

                    {/* Форма */}
                    <div className="shop-account-card" style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                    }}>
                    <form
                        onSubmit={handleSubmit}
                        autoComplete="on"
                        style={{
                            width: '100%',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center'
                        }}
                    >
                    {/* Скрытое поле username — якорь для менеджера паролей браузера */}
                    <input
                        type="text"
                        name="username"
                        autoComplete="username"
                        value={userData?.username || ''}
                        readOnly
                        tabIndex={-1}
                        aria-hidden="true"
                        style={{
                            position: 'absolute',
                            left: '-9999px',
                            width: 1,
                            height: 1,
                            opacity: 0,
                            pointerEvents: 'none'
                        }}
                    />

                    {/* Новый пароль */}
                    <div style={{ 
                        marginBottom: 'var(--spacing-lg)',
                        width: isMobile ? '100%' : undefined
                    }}>
                        <label
                            htmlFor="new-password"
                            className="form-label"
                            style={{
                            fontSize: isMobile ? 'var(--text-base)' : undefined,
                            marginBottom: 'var(--spacing-sm)',
                            display: 'block'
                        }}>
                            New Password
                        </label>
                        <div style={{ position: 'relative' }}>
                            <input
                                id="new-password"
                                name="new-password"
                                type={showPassword ? 'text' : 'password'}
                                autoComplete="new-password"
                                placeholder="Enter your new password"
                                value={passwd}
                                onChange={handleChangePasswd}
                                onBlur={(e) => handleValidatePassword(e.target.value)}
                                className={`form-input ${open ? 'form-input-error' : ''}`}
                                style={{ 
                                    paddingRight: '50px',
                                    fontSize: isMobile ? 'var(--text-base)' : undefined,
                                    minHeight: isMobile ? '44px' : undefined
                                }}
                            />
                            <button
                                type="button"
                                onClick={handleClickShowPassword}
                                onMouseDown={handleMouseDownPassword}
                                style={{
                                    position: 'absolute',
                                    right: '12px',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    background: 'none',
                                    border: 'none',
                                    color: 'var(--text-muted)',
                                    cursor: 'pointer',
                                    padding: isMobile ? '8px' : '4px',
                                    fontSize: isMobile ? '20px' : '18px',
                                    minWidth: isMobile ? '44px' : undefined,
                                    minHeight: isMobile ? '44px' : undefined,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                            >
                                {showPassword ? '👁️‍🗨️' : '👁️'}
                            </button>
                        </div>
                        {passwordHelperText && (
                            <div className="form-error" style={{ minHeight: '20px' }}>
                                {passwordHelperText}
                            </div>
                        )}
                    </div>

                    {/* Подтверждение пароля */}
                    <div style={{ 
                        marginBottom: 'var(--spacing-lg)',
                        width: isMobile ? '100%' : undefined
                    }}>
                        <label
                            htmlFor="confirm-password"
                            className="form-label"
                            style={{
                            fontSize: isMobile ? 'var(--text-base)' : undefined,
                            marginBottom: 'var(--spacing-sm)',
                            display: 'block'
                        }}>
                            Confirm New Password
                        </label>
                        <div style={{ position: 'relative' }}>
                            <input
                                id="confirm-password"
                                name="confirm-password"
                                type={showRePassword ? 'text' : 'password'}
                                autoComplete="new-password"
                                placeholder="Confirm your new password"
                                value={repasswd}
                                onChange={handleChangeRePasswd}
                                onBlur={(e) => validateRePassword(e.target.value)}
                                className={`form-input ${openRePassError ? 'form-input-error' : ''}`}
                                style={{ 
                                    paddingRight: '50px',
                                    fontSize: isMobile ? 'var(--text-base)' : undefined,
                                    minHeight: isMobile ? '44px' : undefined
                                }}
                            />
                            <button
                                type="button"
                                onClick={handleClickShowRePassword}
                                onMouseDown={handleMouseDownPassword}
                                style={{
                                    position: 'absolute',
                                    right: '12px',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    background: 'none',
                                    border: 'none',
                                    color: 'var(--text-muted)',
                                    cursor: 'pointer',
                                    padding: isMobile ? '8px' : '4px',
                                    fontSize: isMobile ? '20px' : '18px',
                                    minWidth: isMobile ? '44px' : undefined,
                                    minHeight: isMobile ? '44px' : undefined,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                            >
                                {showRePassword ? '👁️‍🗨️' : '👁️'}
                            </button>
                        </div>
                        {rePasswordHelperText && (
                            <div className="form-error" style={{ minHeight: '20px' }}>
                                {rePasswordHelperText}
                            </div>
                        )}
                    </div>

                    {/* Общая ошибка */}
                    {isError && (
                        <div className="form-error" style={{ marginBottom: 'var(--spacing-lg)', minHeight: '20px' }}>
                            {errorText}
                        </div>
                    )}

                    {/* Кнопка */}
                    <button
                        type="submit"
                        disabled={buttonDisable}
                        className="btn btn-buy"
                        style={{ 
                            minHeight: isMobile ? '48px' : undefined,
                            fontSize: isMobile ? 'var(--text-base)' : undefined,
                        }}
                    >
                        Change Password
                    </button>
                    </form>
                    </div>
                </div>
            </div>

            {/* Уведомления */}
            {errorChangePassword && (
                <div className="shop-toast" style={{ top: isMobile ? '10px' : '20px' }}>
                    <span className="shop-toast__icon">✕</span>
                    <span className="shop-toast__message">Error changing password.</span>
                    <button type="button" onClick={handleSetErrorPasswordClose} className="shop-toast__close">✕</button>
                </div>
            )}

            {successChangePassword && (
                <div className="shop-toast" style={{ top: isMobile ? '10px' : '20px' }}>
                    <span className="shop-toast__icon">✓</span>
                    <span className="shop-toast__message">Password changed successfully!</span>
                    <button type="button" onClick={handleSetSuccessPasswordClose} className="shop-toast__close">✕</button>
                </div>
            )}
        </div>
    )
}

export default ChangePassword